import axios from 'axios'
import { useTranslation } from 'i11n/client'
import { useCallback } from 'react'
import { useToast } from 'ui/use-toast'

export const useApiError = () => {
  const { toast } = useToast()

  const t = useTranslation()

  const handleError = useCallback((error: any) => {
    console.error('Received error', error, 'error.code', error.code)

    if (
      (axios.isAxiosError(error) && error.response?.data.code) ||
      (typeof error === 'object' && 'code' in error)
    ) {
      const errorCode = error.response?.data?.code || error.code
      const errorMetadata = error.response?.data?.metadata || error.metadata

      return toast({
        title: t(`api_errors.${errorCode}.title`, {
          ...(errorMetadata || {}),
        }),
        description: t(`api_errors.${errorCode}.description`, {
          ...(errorMetadata || {}),
        }),
        variant: 'destructive',
      })
    }

    return toast({
      title: 'Error desconocido',
      description: 'Algo salió mal. Por favor, intenta nuevamente.',
      variant: 'destructive',
    })
  }, [])

  return {
    handleError,
  }
}
